// extracted by mini-css-extract-plugin
module.exports = {"container":"PasswordReset_container__rBzuC","paddingContainer":"PasswordReset_paddingContainer__1ZzyX","noPaddingContainer":"PasswordReset_noPaddingContainer__M4viw"};